export default {
  COUNTRIES: [
    {
      'name': 'Kenya',
      'code': 'KE'
    },
    {
      'name': 'Tanzania',
      'code': 'TZ'
    },
    {
      'name': 'Uganda',
      'code': 'UG'
    },
    {
      'name': 'Zambia',
      'code': 'ZM'
    },
    {
      'name': 'Zimbabwe',
      'code': 'ZW'
    },
    {
      'name': 'Ghana',
      'code': 'GH'
    },
    {
      'name': 'Nigeria',
      'code': 'NG'
    },
    {
      'name': 'Mozambique',
      'code': 'MZ'
    },
    {
      'name': 'Egypt',
      'code': 'EG'
    },
    {
      'name': 'Angola',
      'code': 'AO'
    },
    {
      'name': 'Botswana',
      'code': 'BW'
    },
    {
      'name': 'Burkina Faso',
      'code': 'BF'
    },
    {
      'name': 'Burundi',
      'code': 'BI'
    },
    {
      'name': 'South Africa',
      'code': 'ZA'
    },
    {
      'name': 'Senegal',
      'code': 'SN'
    },
    {
      'name': 'Morocco',
      'code': 'MA'
    },
    {
      'name': 'Ethiopia',
      'code': 'ET'
    },
    {
      'name': "Cote d'Ivoire",
      'code': 'CI'
    },
    {
      'name': 'Tunisia',
      'code': 'TN'
    },
    {
      'name': 'Sudan',
      'code': 'SD'
    },
    {
      'name': 'Guinea Conakry',
      'code': 'GN'
    },
    {
      'name': 'Algeria',
      'code': 'DZ'
    },
    {
      'name': 'Malawi',
      'code': 'MW'
    },
    {
      'name': 'South Sudan',
      'code': 'SS'
    }
  ],
  CURRENCIES: {
    'KE': {
      'name': 'KES',
      'code': 'KES'
    },
    'TZ': {
      'name': 'TZS',
      'code': 'TZS'
    },
    'UG': {
      'name': 'UGX',
      'code': 'UGX'
    },
    'ZW': {
      'name': 'USD',
      'code': 'USD'
    },
    'ZM': {
      'name': 'ZMW',
      'code': 'ZMW'
    },
    'GH': {
      'name': 'GHS',
      'code': 'GHS'
    },
    'NG': {
      'name': 'NGN',
      'code': 'NGN'
    },
    'MZ': {
      'name': 'MZN',
      'code': 'MZN'
    },
    'EG': {
      'name': 'EGP',
      'code': 'EGP'
    },
    'AO': {
      'name': 'AOA',
      'code': 'AOA'
    },
    'BW': {
      'name': 'BWP',
      'code': 'BWP'
    },
    'BF': {
      'name': 'XOF',
      'code': 'XOF'
    },
    'BI': {
      'name': 'BIF',
      'code': 'BIF'
    },
    'ZA': {
      'name': 'ZAR',
      'code': 'ZAR'
    },
    'SN': {
      'name': 'XOF',
      'code': 'XOF'
    },
    'MA': {
      'name': 'MAD',
      'code': 'MAD'
    },
    'ET': {
      'name': 'ETB',
      'code': 'ETB'
    },
    'CI': {
      'name': 'XOF',
      'code': 'XOF'
    },
    'TN': {
      'name': 'TND',
      'code': 'TND'
    },
    'GN': {
      'name': 'GNF',
      'code': 'GNF'
    },
    'SD': {
      'name': 'SDG',
      'code': 'SDG'
    },
    'DZ': {
      'name': 'DZD',
      'code': 'DZD'
    },
    'ML': {
      'name': 'XOF',
      'code': 'XOF'
     }, 
    'MW': {
      'name': 'MWK',
      'code': 'MWK'
    },
    'Global': {
      'name': 'USD',
      'code': 'USD'
    }
  },
  ENGINE_PROXY_URL: 'https://developer.tingg.africa/checkout/v2/portal-proxy/api/engine/',
  PAYMENT_WEBHOOK_URL: 'https://developer.tingg.africa/checkout/v2/portal-proxy/api/webhook/callback',
  EXPRESS_CALLBACK_URL: 'https://developer.tingg.africa/checkout/v2/portal-proxy/api/express/callback',
  ERROR_MESSAGES: {
    7: `Whoops! Something wring happened. <br> Please try again`,
    53: `Seems like you already have an account <br> with the same email address`
  },
  LOGO_URLS: {
    KE: 'https://beep2.cellulant.africa:9001/hub/admin/images/logos/med96',
    TZ: 'https://beep2.cellulant.africa:9001/hub/admin/images/logos/med96',
    UG: 'https://beep2.cellulant.africa:9001/hub/admin/images/logos/med96'
  },
  SESSION_EXPIRY_TIME: 1 / 24
}



// WEBPACK FOOTER //
// ./src/api/config.js